const routes: App.IObject = {
  calculatorPage: '/calculator',
  error: '/error/404'
};

export default  routes;